/* ===========================================================================
 * DOES THIS RING CONTAIN THE WORD THAT WAS SEARCHED FOR? THE JAVASCRIPT HALF.
 *
 * The rule itself, the filler words and the whole argument for it are in
 * snippets/sp-search-match.liquid, which is the Liquid half and the place to
 * read. This is the same rule for the two places that need it in the browser:
 *
 *   sections/header.liquid   the suggestions, matching against the ring index
 *   assets/sp-catalog.js     the search page, matching against the catalogue
 *
 * ONE COPY, NOT TWO. It was inline in assets/sp-catalog.js until 25 October
 * 2026, when the header needed it as well; a second copy in the header would
 * have been a second rule waiting to disagree with the first. The filler list is
 * still written down only in the Liquid snippet and is handed to this file by
 * whoever calls it, so there is one list and one rule between the three files.
 *
 * IF THIS FILE NEVER ARRIVES, nothing breaks and nothing is wrong: the search
 * page shows Shopify's own list unfiltered - which is exactly what the shop did
 * before any of this - and the suggestions do the same. Both callers check for
 * the global before they use it.
 * =========================================================================== */
(function () {
  'use strict';

  if (window.SestoSearchMatch) { return; }

  /* THE TEXT OF A RING, from whichever feed it came out of. The two feeds use
     the same letters for the same things: t title, g tags, m materials, y type,
     o options - and o is an ARRAY OF OBJECTS in the catalogue feed ({n,v}) and a
     plain string in the slim index, because the index has no use for the option
     NAMES. Both shapes are read here so neither caller has to care.

     THE DESCRIPTION IS NOT IN EITHER FEED AND THAT IS THE POINT: Shopify has
     already searched it, and it is where the weak matches come from. */
  /* NOT THE DESIGN TAGS. Lorenzo, 25 October 2026: "when I search essence I see Oasis in the reasult
     which is because its design is essence. keep design out of the query match".
     A ring's design is its Design_<name> tag; a ring's OWN name is its title,
     which is still searched, so "essence" still finds The Essence. The
     catalogue feed carries the tags as an array and loses only these here (its
     filters read the feed, not this text); the slim index leaves them out where
     it is written, templates/collection.sp-search-index.liquid. */
  function notDesign(tag) {
    return String(tag || '').toLowerCase().indexOf('design_') !== 0;
  }

  function text(p) {
    var bits = [p.t || '', p.y || '', p.m || ''];
    if (p.g) { bits.push(typeof p.g === 'string' ? p.g : p.g.filter(notDesign).join(' ')); }
    if (p.o) {
      if (typeof p.o === 'string') { bits.push(p.o); }
      else {
        p.o.forEach(function (opt) {
          if (!opt) { return; }
          if (typeof opt === 'string') { bits.push(opt); }
          else if (opt.v) { bits.push(opt.v.join(' ')); }
        });
      }
    }
    return bits.join(' ').toLowerCase();
  }

  /* One word, as a substring - so "meteor" finds "meteorite". A word that is not
     found is tried again without a trailing "es" and then without a trailing
     "s", so "opals" finds "opal" and "inlays" finds "inlay". */
  function wordIn(hay, word) {
    if (hay.indexOf(word) > -1) { return true; }
    if (word.length > 2 && word.slice(-2) === 'es' && hay.indexOf(word.slice(0, -2)) > -1) { return true; }
    if (word.length > 1 && word.slice(-1) === 's' && hay.indexOf(word.slice(0, -1)) > -1) { return true; }
    return false;
  }

  function matches(p, words) {
    var hay = text(p);
    for (var i = 0; i < words.length; i++) {
      if (!wordIn(hay, words[i])) { return false; }
    }
    return true;
  }

  /* The query, cleaned the same way snippets/sp-search-match.liquid cleans it:
     lower-cased, apostrophes dropped so "men's" becomes "mens", split on
     anything that is not a letter or a number, and the filler words taken out.
     THE FILLER LIST IS THE CALLER'S, because it is written down once, in the
     Liquid snippet, and travels from there. */
  function words(terms, fillers) {
    var list = fillers || [];
    return String(terms || '')
      .toLowerCase()
      .replace(/['’]/g, '')
      .split(/[^a-z0-9]+/)
      .filter(function (w) { return w && list.indexOf(w) === -1; });
  }

  /* Everything that matches, in the order it was given. An EMPTY ANSWER IS AN
     ANSWER: the caller decides what to do with it, and both callers fall back to
     Shopify's own list rather than showing an empty page, which is what keeps a
     misspelling working. */
  function keep(items, ws) {
    if (!items || !ws || !ws.length) { return items || []; }
    return items.filter(function (p) { return matches(p, ws); });
  }

  /* Does the TITLE alone carry every word? The search page puts those first in
     its relevance order and the suggestions draw them first, because a shopper
     who types "stripe" means The Stripe before a ring that merely has a stripe
     somewhere in its tags. */
  function titleHit(p, ws) {
    var hay = String(p.t || '').toLowerCase();
    for (var i = 0; i < ws.length; i++) {
      if (!wordIn(hay, ws[i])) { return false; }
    }
    return true;
  }

  window.SestoSearchMatch = {
    text: text,
    words: words,
    matches: matches,
    keep: keep,
    titleHit: titleHit
  };
}());
